(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8354],{

/***/ 37752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./": [
		52898
	],
	"./AllIn": [
		73778
	],
	"./AllIn/": [
		73778
	],
	"./AllIn/addToWishlist": [
		64246
	],
	"./AllIn/addToWishlist.js": [
		64246
	],
	"./AllIn/index": [
		73778
	],
	"./AllIn/index.js": [
		73778
	],
	"./AllIn/pageView": [
		21036
	],
	"./AllIn/pageView.js": [
		21036
	],
	"./AllIn/subscribeToNewsletter": [
		81180
	],
	"./AllIn/subscribeToNewsletter.js": [
		81180
	],
	"./AllIn/utils/constants": [
		70551
	],
	"./AllIn/utils/constants.js": [
		70551
	],
	"./Bing": [
		10482
	],
	"./Bing/": [
		10482
	],
	"./Bing/addToCart": [
		88375
	],
	"./Bing/addToCart.js": [
		88375
	],
	"./Bing/index": [
		10482
	],
	"./Bing/index.js": [
		10482
	],
	"./Bing/pageView": [
		48863
	],
	"./Bing/pageView.js": [
		48863
	],
	"./Bing/utils/formatProductIdBing": [
		29841
	],
	"./Bing/utils/formatProductIdBing.js": [
		29841
	],
	"./CloudRetail": [
		80542
	],
	"./CloudRetail/": [
		80542
	],
	"./CloudRetail/events": [
		57046
	],
	"./CloudRetail/events/": [
		57046
	],
	"./CloudRetail/events/addToCart": [
		33373
	],
	"./CloudRetail/events/addToCart.js": [
		33373
	],
	"./CloudRetail/events/category": [
		80548
	],
	"./CloudRetail/events/category.js": [
		80548
	],
	"./CloudRetail/events/index": [
		57046
	],
	"./CloudRetail/events/index.js": [
		57046
	],
	"./CloudRetail/events/search": [
		89913
	],
	"./CloudRetail/events/search.js": [
		89913
	],
	"./CloudRetail/events/subCategory": [
		79564
	],
	"./CloudRetail/events/subCategory.js": [
		79564
	],
	"./CloudRetail/events/viewItem": [
		78336
	],
	"./CloudRetail/events/viewItem.js": [
		78336
	],
	"./CloudRetail/index": [
		80542
	],
	"./CloudRetail/index.js": [
		80542
	],
	"./Cookies": [
		30040
	],
	"./Cookies/": [
		30040
	],
	"./Cookies/addAcceptPolity": [
		78224
	],
	"./Cookies/addAcceptPolity.js": [
		78224
	],
	"./Cookies/addRejectZipcodePopup": [
		72661
	],
	"./Cookies/addRejectZipcodePopup.js": [
		72661
	],
	"./Cookies/addToCart": [
		84511
	],
	"./Cookies/addToCart.js": [
		84511
	],
	"./Cookies/index": [
		30040
	],
	"./Cookies/index.js": [
		30040
	],
	"./Cookies/setPageBeforeLogin": [
		29414
	],
	"./Cookies/setPageBeforeLogin.js": [
		29414
	],
	"./Criteo": [
		79381
	],
	"./Criteo/": [
		79381
	],
	"./Criteo/index": [
		79381
	],
	"./Criteo/index.js": [
		79381
	],
	"./Criteo/pageView": [
		91564
	],
	"./Criteo/pageView.js": [
		91564
	],
	"./Criteo/utils/constants": [
		33385
	],
	"./Criteo/utils/constants.js": [
		33385
	],
	"./GA": [
		19487
	],
	"./GA/": [
		19487
	],
	"./GA/events": [
		6115
	],
	"./GA/events/": [
		6115
	],
	"./GA/events/addtocart": [
		78807
	],
	"./GA/events/addtocart.js": [
		78807
	],
	"./GA/events/blogPageView": [
		97100
	],
	"./GA/events/blogPageView.js": [
		97100
	],
	"./GA/events/blogPost": [
		6870
	],
	"./GA/events/blogPost.js": [
		6870
	],
	"./GA/events/blogbutton": [
		73191
	],
	"./GA/events/blogbutton.js": [
		73191
	],
	"./GA/events/buybox": [
		31956
	],
	"./GA/events/buybox.js": [
		31956
	],
	"./GA/events/buybutton": [
		58346
	],
	"./GA/events/buybutton.js": [
		58346
	],
	"./GA/events/buybuttonServices": [
		68789
	],
	"./GA/events/buybuttonServices.js": [
		68789
	],
	"./GA/events/cardan": [
		59190
	],
	"./GA/events/cardan.js": [
		59190
	],
	"./GA/events/chatConversationFollowSeller": [
		82378
	],
	"./GA/events/chatConversationFollowSeller.js": [
		82378
	],
	"./GA/events/chatbotLu": [
		6450
	],
	"./GA/events/chatbotLu.js": [
		6450
	],
	"./GA/events/constants": [
		59075
	],
	"./GA/events/constants.js": [
		59075
	],
	"./GA/events/continueToCart": [
		7779
	],
	"./GA/events/continueToCart.js": [
		7779
	],
	"./GA/events/didYouMean": [
		71330
	],
	"./GA/events/didYouMean.js": [
		71330
	],
	"./GA/events/displayType": [
		1602
	],
	"./GA/events/displayType.js": [
		1602
	],
	"./GA/events/filter": [
		64056
	],
	"./GA/events/filter.js": [
		64056
	],
	"./GA/events/financialServicesSeparateSale": [
		75088
	],
	"./GA/events/financialServicesSeparateSale.js": [
		75088
	],
	"./GA/events/gatekeeperbutton": [
		96134
	],
	"./GA/events/gatekeeperbutton.js": [
		96134
	],
	"./GA/events/hotlinks": [
		8139
	],
	"./GA/events/hotlinks.js": [
		8139
	],
	"./GA/events/index": [
		6115
	],
	"./GA/events/index.js": [
		6115
	],
	"./GA/events/linkSuggestions": [
		48383
	],
	"./GA/events/linkSuggestions.js": [
		48383
	],
	"./GA/events/luContent": [
		89937
	],
	"./GA/events/luContent.js": [
		89937
	],
	"./GA/events/menu": [
		1772
	],
	"./GA/events/menu.js": [
		1772
	],
	"./GA/events/miniapps": [
		23481
	],
	"./GA/events/miniapps.js": [
		23481
	],
	"./GA/events/pageView": [
		96617
	],
	"./GA/events/pageView.js": [
		96617
	],
	"./GA/events/paginate": [
		64141
	],
	"./GA/events/paginate.js": [
		64141
	],
	"./GA/events/pmdShareLinks": [
		66298
	],
	"./GA/events/pmdShareLinks.js": [
		66298
	],
	"./GA/events/product": [
		63707
	],
	"./GA/events/product.js": [
		63707
	],
	"./GA/events/productBenefits": [
		44541
	],
	"./GA/events/productBenefits.js": [
		44541
	],
	"./GA/events/productLabels": [
		39478
	],
	"./GA/events/productLabels.js": [
		39478
	],
	"./GA/events/productList": [
		84638
	],
	"./GA/events/productList.js": [
		84638
	],
	"./GA/events/productTags": [
		1041
	],
	"./GA/events/productTags.js": [
		1041
	],
	"./GA/events/promotionBanner": [
		31519
	],
	"./GA/events/promotionBanner.js": [
		31519
	],
	"./GA/events/questions": [
		84093
	],
	"./GA/events/questions.js": [
		84093
	],
	"./GA/events/review": [
		56778
	],
	"./GA/events/review.js": [
		56778
	],
	"./GA/events/reviewFilterClick": [
		42354
	],
	"./GA/events/reviewFilterClick.js": [
		42354
	],
	"./GA/events/reviewFormSubmit": [
		96866
	],
	"./GA/events/reviewFormSubmit.js": [
		96866
	],
	"./GA/events/search": [
		87003
	],
	"./GA/events/search.js": [
		87003
	],
	"./GA/events/sellerChat": [
		48339
	],
	"./GA/events/sellerChat.js": [
		48339
	],
	"./GA/events/sellerDetails": [
		92908
	],
	"./GA/events/sellerDetails.js": [
		92908
	],
	"./GA/events/services": [
		42340
	],
	"./GA/events/services.js": [
		42340
	],
	"./GA/events/shipping": [
		90803
	],
	"./GA/events/shipping.js": [
		90803
	],
	"./GA/events/signin": [
		84950
	],
	"./GA/events/signin.js": [
		84950
	],
	"./GA/events/sort": [
		77948,
		7948
	],
	"./GA/events/sort.js": [
		77948,
		7948
	],
	"./GA/events/spacePageView": [
		29563
	],
	"./GA/events/spacePageView.js": [
		29563
	],
	"./GA/events/subcategoryList": [
		43444
	],
	"./GA/events/subcategoryList.js": [
		43444
	],
	"./GA/events/suggestionImpression": [
		81656
	],
	"./GA/events/suggestionImpression.js": [
		81656
	],
	"./GA/events/viewItem": [
		67663
	],
	"./GA/events/viewItem.js": [
		67663
	],
	"./GA/events/zipCodeBar": [
		46091
	],
	"./GA/events/zipCodeBar.js": [
		46091
	],
	"./GA/index": [
		19487
	],
	"./GA/index.js": [
		19487
	],
	"./GA/utils": [
		90545
	],
	"./GA/utils/": [
		90545
	],
	"./GA/utils/buildClickCommonEvent": [
		19777
	],
	"./GA/utils/buildClickCommonEvent.js": [
		19777
	],
	"./GA/utils/categoryToString": [
		98011
	],
	"./GA/utils/categoryToString.js": [
		98011
	],
	"./GA/utils/channelStoreDimensions": [
		27903
	],
	"./GA/utils/channelStoreDimensions.js": [
		27903
	],
	"./GA/utils/dataLayerPush": [
		24169
	],
	"./GA/utils/dataLayerPush.js": [
		24169
	],
	"./GA/utils/ga4ParseDimensions": [
		53004
	],
	"./GA/utils/ga4ParseDimensions.js": [
		53004
	],
	"./GA/utils/gaBoolean": [
		20914
	],
	"./GA/utils/gaBoolean.js": [
		20914
	],
	"./GA/utils/gaEcommerceProduct": [
		15950
	],
	"./GA/utils/gaEcommerceProduct.js": [
		15950
	],
	"./GA/utils/gaSelectedFilters": [
		66724
	],
	"./GA/utils/gaSelectedFilters.js": [
		66724
	],
	"./GA/utils/getBestPriceDiscount": [
		82115
	],
	"./GA/utils/getBestPriceDiscount.js": [
		82115
	],
	"./GA/utils/getDiscount": [
		54730
	],
	"./GA/utils/getDiscount.js": [
		54730
	],
	"./GA/utils/getInstallmentQuantity": [
		50734
	],
	"./GA/utils/getInstallmentQuantity.js": [
		50734
	],
	"./GA/utils/getSearchTerm": [
		6983
	],
	"./GA/utils/getSearchTerm.js": [
		6983
	],
	"./GA/utils/getTypeButton": [
		22078
	],
	"./GA/utils/getTypeButton.js": [
		22078
	],
	"./GA/utils/handleOrigin": [
		10924
	],
	"./GA/utils/handleOrigin.js": [
		10924
	],
	"./GA/utils/index": [
		90545
	],
	"./GA/utils/index.js": [
		90545
	],
	"./GA/utils/isSomeParametersEmpty": [
		12530
	],
	"./GA/utils/isSomeParametersEmpty.js": [
		12530
	],
	"./GA/utils/productFormatter": [
		67412
	],
	"./GA/utils/productFormatter.js": [
		67412
	],
	"./GA4": [
		57016
	],
	"./GA4/": [
		57016
	],
	"./GA4/events": [
		36082
	],
	"./GA4/events/": [
		36082
	],
	"./GA4/events/accountLinkClick": [
		51852
	],
	"./GA4/events/accountLinkClick.js": [
		51852
	],
	"./GA4/events/addToCart": [
		86963
	],
	"./GA4/events/addToCart.js": [
		86963
	],
	"./GA4/events/addToCartWarranty": [
		81760
	],
	"./GA4/events/addToCartWarranty.js": [
		81760
	],
	"./GA4/events/addToWishlist": [
		72003
	],
	"./GA4/events/addToWishlist.js": [
		72003
	],
	"./GA4/events/allBrands": [
		21384
	],
	"./GA4/events/allBrands.js": [
		21384
	],
	"./GA4/events/calculateTaxes": [
		82022
	],
	"./GA4/events/calculateTaxes.js": [
		82022
	],
	"./GA4/events/constants": [
		30821
	],
	"./GA4/events/constants.js": [
		30821
	],
	"./GA4/events/coupon": [
		38015
	],
	"./GA4/events/coupon.js": [
		38015
	],
	"./GA4/events/filterGA4": [
		65086
	],
	"./GA4/events/filterGA4.js": [
		65086
	],
	"./GA4/events/footerEvents": [
		5503
	],
	"./GA4/events/footerEvents.js": [
		5503
	],
	"./GA4/events/importTaxesInfoModalClose": [
		45073
	],
	"./GA4/events/importTaxesInfoModalClose.js": [
		45073
	],
	"./GA4/events/index": [
		36082
	],
	"./GA4/events/index.js": [
		36082
	],
	"./GA4/events/orderEligibleList": [
		27341
	],
	"./GA4/events/orderEligibleList.js": [
		27341
	],
	"./GA4/events/quickClick": [
		64233
	],
	"./GA4/events/quickClick.js": [
		64233
	],
	"./GA4/events/removeFromCart": [
		3837
	],
	"./GA4/events/removeFromCart.js": [
		3837
	],
	"./GA4/events/removeFromWishList": [
		25790
	],
	"./GA4/events/removeFromWishList.js": [
		25790
	],
	"./GA4/events/reviewAttachMedia": [
		38774
	],
	"./GA4/events/reviewAttachMedia.js": [
		38774
	],
	"./GA4/events/reviewCondensedMedia": [
		16539
	],
	"./GA4/events/reviewCondensedMedia.js": [
		16539
	],
	"./GA4/events/reviewFormSubmitModal": [
		55442
	],
	"./GA4/events/reviewFormSubmitModal.js": [
		55442
	],
	"./GA4/events/reviewMediasClick": [
		49070,
		9070
	],
	"./GA4/events/reviewMediasClick.js": [
		49070,
		9070
	],
	"./GA4/events/search": [
		13075
	],
	"./GA4/events/search.js": [
		13075
	],
	"./GA4/events/selectContent": [
		80773
	],
	"./GA4/events/selectContent.js": [
		80773
	],
	"./GA4/events/selectContentHeader": [
		23620
	],
	"./GA4/events/selectContentHeader.js": [
		23620
	],
	"./GA4/events/selectItem": [
		55544
	],
	"./GA4/events/selectItem.js": [
		55544
	],
	"./GA4/events/selectPromotion": [
		4193
	],
	"./GA4/events/selectPromotion.js": [
		4193
	],
	"./GA4/events/share": [
		87889
	],
	"./GA4/events/share.js": [
		87889
	],
	"./GA4/events/shipping": [
		35468
	],
	"./GA4/events/shipping.js": [
		35468
	],
	"./GA4/events/shippingError": [
		53827
	],
	"./GA4/events/shippingError.js": [
		53827
	],
	"./GA4/events/showCaseSelectContent": [
		41547
	],
	"./GA4/events/showCaseSelectContent.js": [
		41547
	],
	"./GA4/events/sort": [
		74359
	],
	"./GA4/events/sort.js": [
		74359
	],
	"./GA4/events/summaryTechnicalSheet": [
		52571
	],
	"./GA4/events/summaryTechnicalSheet.js": [
		52571
	],
	"./GA4/events/viewContentHeader": [
		29371
	],
	"./GA4/events/viewContentHeader.js": [
		29371
	],
	"./GA4/events/viewItem": [
		75589
	],
	"./GA4/events/viewItem.js": [
		75589
	],
	"./GA4/events/viewItemList": [
		20944
	],
	"./GA4/events/viewItemList.js": [
		20944
	],
	"./GA4/events/viewPromotion": [
		67155
	],
	"./GA4/events/viewPromotion.js": [
		67155
	],
	"./GA4/events/virtualPageview": [
		14093
	],
	"./GA4/events/virtualPageview.js": [
		14093
	],
	"./GA4/index": [
		57016
	],
	"./GA4/index.js": [
		57016
	],
	"./GA4/utils": [
		80196,
		196
	],
	"./GA4/utils/": [
		80196,
		196
	],
	"./GA4/utils/addToCartDimensions": [
		33637
	],
	"./GA4/utils/addToCartDimensions.js": [
		33637
	],
	"./GA4/utils/addToWishlistDimensions": [
		8886
	],
	"./GA4/utils/addToWishlistDimensions.js": [
		8886
	],
	"./GA4/utils/buildDimensions": [
		6325
	],
	"./GA4/utils/buildDimensions.js": [
		6325
	],
	"./GA4/utils/dataLayerPush": [
		45842
	],
	"./GA4/utils/dataLayerPush.js": [
		45842
	],
	"./GA4/utils/dataLayerPushQueue": [
		60604
	],
	"./GA4/utils/dataLayerPushQueue.js": [
		60604
	],
	"./GA4/utils/discountCalc": [
		80746
	],
	"./GA4/utils/discountCalc.js": [
		80746
	],
	"./GA4/utils/formattedTagSelo": [
		19175
	],
	"./GA4/utils/formattedTagSelo.js": [
		19175
	],
	"./GA4/utils/index": [
		80196,
		196
	],
	"./GA4/utils/index.js": [
		80196,
		196
	],
	"./GA4/utils/itemVariantParser": [
		58338
	],
	"./GA4/utils/itemVariantParser.js": [
		58338
	],
	"./GA4/utils/parseUrl": [
		62322
	],
	"./GA4/utils/parseUrl.js": [
		62322
	],
	"./GA4/utils/paymentMethods": [
		49085,
		9085
	],
	"./GA4/utils/paymentMethods.js": [
		49085,
		9085
	],
	"./GA4/utils/selectItemDimensions": [
		12608
	],
	"./GA4/utils/selectItemDimensions.js": [
		12608
	],
	"./GA4/utils/viewItemDimensions": [
		87191
	],
	"./GA4/utils/viewItemDimensions.js": [
		87191
	],
	"./GA4/utils/wishlistItem": [
		988
	],
	"./GA4/utils/wishlistItem.js": [
		988
	],
	"./Kwai": [
		40649
	],
	"./Kwai/": [
		40649
	],
	"./Kwai/events": [
		77981
	],
	"./Kwai/events/": [
		77981
	],
	"./Kwai/events/addToCart": [
		19536
	],
	"./Kwai/events/addToCart.js": [
		19536
	],
	"./Kwai/events/index": [
		77981
	],
	"./Kwai/events/index.js": [
		77981
	],
	"./Kwai/events/pageView": [
		9327
	],
	"./Kwai/events/pageView.js": [
		9327
	],
	"./Kwai/index": [
		40649
	],
	"./Kwai/index.js": [
		40649
	],
	"./Kwai/utils/buildProduct": [
		88985
	],
	"./Kwai/utils/buildProduct.js": [
		88985
	],
	"./MagaluAds": [
		66202,
		6202
	],
	"./MagaluAds/": [
		66202,
		6202
	],
	"./MagaluAds/events": [
		12271,
		2271
	],
	"./MagaluAds/events/": [
		12271,
		2271
	],
	"./MagaluAds/events/index": [
		12271,
		2271
	],
	"./MagaluAds/events/index.js": [
		12271,
		2271
	],
	"./MagaluAds/events/searchEvent/buildSearchEvent": [
		55634,
		5634
	],
	"./MagaluAds/events/searchEvent/buildSearchEvent.js": [
		55634,
		5634
	],
	"./MagaluAds/events/searchEvent/searchProductListClick": [
		48133,
		8133
	],
	"./MagaluAds/events/searchEvent/searchProductListClick.js": [
		48133,
		8133
	],
	"./MagaluAds/events/searchEvent/searchProductListImpression": [
		9652,
		9652
	],
	"./MagaluAds/events/searchEvent/searchProductListImpression.js": [
		9652,
		9652
	],
	"./MagaluAds/events/searchEvent/searchProductListView": [
		27368,
		7368
	],
	"./MagaluAds/events/searchEvent/searchProductListView.js": [
		27368,
		7368
	],
	"./MagaluAds/events/showcaseEvent/showcaseProductListClick": [
		71658,
		1658
	],
	"./MagaluAds/events/showcaseEvent/showcaseProductListClick.js": [
		71658,
		1658
	],
	"./MagaluAds/events/showcaseEvent/showcaseProductListImpression": [
		7145,
		7145
	],
	"./MagaluAds/events/showcaseEvent/showcaseProductListImpression.js": [
		7145,
		7145
	],
	"./MagaluAds/events/showcaseEvent/showcaseProductListView": [
		83990,
		3990
	],
	"./MagaluAds/events/showcaseEvent/showcaseProductListView.js": [
		83990,
		3990
	],
	"./MagaluAds/index": [
		66202,
		6202
	],
	"./MagaluAds/index.js": [
		66202,
		6202
	],
	"./MagaluAds/utils/adsConstants": [
		48924,
		8924
	],
	"./MagaluAds/utils/adsConstants.js": [
		48924,
		8924
	],
	"./MagaluAds/utils/decodeAdMetadata": [
		10865,
		865
	],
	"./MagaluAds/utils/decodeAdMetadata.js": [
		10865,
		865
	],
	"./MagaluAds/utils/eventBuilder": [
		84839,
		4839
	],
	"./MagaluAds/utils/eventBuilder.js": [
		84839,
		4839
	],
	"./MagaluAds/utils/extractAdId": [
		79870,
		9870
	],
	"./MagaluAds/utils/extractAdId.js": [
		79870,
		9870
	],
	"./MiniAppSdk": [
		10379
	],
	"./MiniAppSdk/": [
		10379
	],
	"./MiniAppSdk/events": [
		65635
	],
	"./MiniAppSdk/events/": [
		65635
	],
	"./MiniAppSdk/events/index": [
		65635
	],
	"./MiniAppSdk/events/index.js": [
		65635
	],
	"./MiniAppSdk/hooks/useSdkLogin": [
		16468
	],
	"./MiniAppSdk/hooks/useSdkLogin.js": [
		16468
	],
	"./MiniAppSdk/index": [
		10379
	],
	"./MiniAppSdk/index.js": [
		10379
	],
	"./PmdActions": [
		41234
	],
	"./PmdActions/": [
		41234
	],
	"./PmdActions/giveActionPoints": [
		3703
	],
	"./PmdActions/giveActionPoints.js": [
		3703
	],
	"./PmdActions/index": [
		41234
	],
	"./PmdActions/index.js": [
		41234
	],
	"./PmdCartCookie": [
		86823
	],
	"./PmdCartCookie/": [
		86823
	],
	"./PmdCartCookie/addToCart": [
		99141
	],
	"./PmdCartCookie/addToCart.js": [
		99141
	],
	"./PmdCartCookie/buyButtonsClick": [
		25801
	],
	"./PmdCartCookie/buyButtonsClick.js": [
		25801
	],
	"./PmdCartCookie/index": [
		86823
	],
	"./PmdCartCookie/index.js": [
		86823
	],
	"./PmdCartCookie/normalizeStoreName": [
		58373
	],
	"./PmdCartCookie/normalizeStoreName.js": [
		58373
	],
	"./PmdCartCookie/pmdCookieCheckout": [
		58996
	],
	"./PmdCartCookie/pmdCookieCheckout.js": [
		58996
	],
	"./PmeCartCookie": [
		58579
	],
	"./PmeCartCookie/": [
		58579
	],
	"./PmeCartCookie/addToCart": [
		3433
	],
	"./PmeCartCookie/addToCart.js": [
		3433
	],
	"./PmeCartCookie/buyButtonsClick": [
		29805
	],
	"./PmeCartCookie/buyButtonsClick.js": [
		29805
	],
	"./PmeCartCookie/index": [
		58579
	],
	"./PmeCartCookie/index.js": [
		58579
	],
	"./PmeCartCookie/pmeCookieCheckout": [
		59765
	],
	"./PmeCartCookie/pmeCookieCheckout.js": [
		59765
	],
	"./RTBHouse": [
		40789
	],
	"./RTBHouse/": [
		40789
	],
	"./RTBHouse/events": [
		23018
	],
	"./RTBHouse/events/": [
		23018
	],
	"./RTBHouse/events/CategoryPageView": [
		89923
	],
	"./RTBHouse/events/CategoryPageView.js": [
		89923
	],
	"./RTBHouse/events/HomePageView": [
		71238
	],
	"./RTBHouse/events/HomePageView.js": [
		71238
	],
	"./RTBHouse/events/addToCart": [
		64054
	],
	"./RTBHouse/events/addToCart.js": [
		64054
	],
	"./RTBHouse/events/index": [
		23018
	],
	"./RTBHouse/events/index.js": [
		23018
	],
	"./RTBHouse/events/pdpClickWishlist": [
		50448
	],
	"./RTBHouse/events/pdpClickWishlist.js": [
		50448
	],
	"./RTBHouse/events/pdpPageView": [
		9063
	],
	"./RTBHouse/events/pdpPageView.js": [
		9063
	],
	"./RTBHouse/events/placebo": [
		96913
	],
	"./RTBHouse/events/placebo.js": [
		96913
	],
	"./RTBHouse/events/promotionalPageView": [
		56355
	],
	"./RTBHouse/events/promotionalPageView.js": [
		56355
	],
	"./RTBHouse/events/searchPageView": [
		41654
	],
	"./RTBHouse/events/searchPageView.js": [
		41654
	],
	"./RTBHouse/index": [
		40789
	],
	"./RTBHouse/index.js": [
		40789
	],
	"./SpotifyAdAnalytics": [
		7223
	],
	"./SpotifyAdAnalytics/": [
		7223
	],
	"./SpotifyAdAnalytics/events": [
		94554
	],
	"./SpotifyAdAnalytics/events/": [
		94554
	],
	"./SpotifyAdAnalytics/events/PageView": [
		88935
	],
	"./SpotifyAdAnalytics/events/PageView.js": [
		88935
	],
	"./SpotifyAdAnalytics/events/ProductView": [
		71850
	],
	"./SpotifyAdAnalytics/events/ProductView.js": [
		71850
	],
	"./SpotifyAdAnalytics/events/addToCart": [
		53085
	],
	"./SpotifyAdAnalytics/events/addToCart.js": [
		53085
	],
	"./SpotifyAdAnalytics/events/addToWishList": [
		80273
	],
	"./SpotifyAdAnalytics/events/addToWishList.js": [
		80273
	],
	"./SpotifyAdAnalytics/events/index": [
		94554
	],
	"./SpotifyAdAnalytics/events/index.js": [
		94554
	],
	"./SpotifyAdAnalytics/index": [
		7223
	],
	"./SpotifyAdAnalytics/index.js": [
		7223
	],
	"./Stewie": [
		89206
	],
	"./Stewie/": [
		89206
	],
	"./Stewie/index": [
		89206
	],
	"./Stewie/index.js": [
		89206
	],
	"./Stewie/newsletterSuccess": [
		59577
	],
	"./Stewie/newsletterSuccess.js": [
		59577
	],
	"./Stewie/pageView": [
		92901
	],
	"./Stewie/pageView.js": [
		92901
	],
	"./Stewie/productAddCart": [
		28061
	],
	"./Stewie/productAddCart.js": [
		28061
	],
	"./Stewie/productDetail": [
		53388
	],
	"./Stewie/productDetail.js": [
		53388
	],
	"./Stewie/productListClick": [
		19399
	],
	"./Stewie/productListClick.js": [
		19399
	],
	"./TikTok": [
		41535
	],
	"./TikTok/": [
		41535
	],
	"./TikTok/events": [
		17695
	],
	"./TikTok/events/": [
		17695
	],
	"./TikTok/events/addToCart": [
		11887
	],
	"./TikTok/events/addToCart.js": [
		11887
	],
	"./TikTok/events/index": [
		17695
	],
	"./TikTok/events/index.js": [
		17695
	],
	"./TikTok/events/viewItem": [
		91268
	],
	"./TikTok/events/viewItem.js": [
		91268
	],
	"./TikTok/index": [
		41535
	],
	"./TikTok/index.js": [
		41535
	],
	"./TikTok/utils/buildProduct": [
		79583
	],
	"./TikTok/utils/buildProduct.js": [
		79583
	],
	"./index": [
		52898
	],
	"./index.js": [
		52898
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 37752;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 70017:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./": [
		36868
	],
	"./Accessibility": [
		63761
	],
	"./Accessibility.js": [
		63761
	],
	"./Addition": [
		16736
	],
	"./Addition.js": [
		16736
	],
	"./Airplane": [
		93402
	],
	"./Airplane.js": [
		93402
	],
	"./AlarmClock": [
		40836
	],
	"./AlarmClock.js": [
		40836
	],
	"./AlertOperation": [
		62544
	],
	"./AlertOperation.js": [
		62544
	],
	"./AlertOutline": [
		61443
	],
	"./AlertOutline.js": [
		61443
	],
	"./AnimatedLoading1": [
		74630
	],
	"./AnimatedLoading1.js": [
		74630
	],
	"./AnimatedLoading2": [
		34623
	],
	"./AnimatedLoading2.js": [
		34623
	],
	"./AnimatedLoading3": [
		42832
	],
	"./AnimatedLoading3.js": [
		42832
	],
	"./AnimatedLoadingColorful": [
		75731
	],
	"./AnimatedLoadingColorful.js": [
		75731
	],
	"./AnimatedLoadingColorful2": [
		63137
	],
	"./AnimatedLoadingColorful2.js": [
		63137
	],
	"./ArrowBack": [
		50575
	],
	"./ArrowBack.js": [
		50575
	],
	"./ArrowDownRight": [
		16610
	],
	"./ArrowDownRight.js": [
		16610
	],
	"./ArrowDropDown": [
		80056
	],
	"./ArrowDropDown.js": [
		80056
	],
	"./ArrowDropUp": [
		94467
	],
	"./ArrowDropUp.js": [
		94467
	],
	"./ArrowForward": [
		33081
	],
	"./ArrowForward.js": [
		33081
	],
	"./ArrowLeft": [
		57608
	],
	"./ArrowLeft.js": [
		57608
	],
	"./ArrowRight": [
		94303
	],
	"./ArrowRight.js": [
		94303
	],
	"./BackToTop": [
		65743
	],
	"./BackToTop.js": [
		65743
	],
	"./BankSlip": [
		72286
	],
	"./BankSlip.js": [
		72286
	],
	"./Blog": [
		17054
	],
	"./Blog.js": [
		17054
	],
	"./BordererQuestionMark": [
		15992,
		5992
	],
	"./BordererQuestionMark.js": [
		15992,
		5992
	],
	"./BoxChecked": [
		74218
	],
	"./BoxChecked.js": [
		74218
	],
	"./BoxUnchecked": [
		48079
	],
	"./BoxUnchecked.js": [
		48079
	],
	"./Burger": [
		97639
	],
	"./Burger.js": [
		97639
	],
	"./Camera": [
		32143
	],
	"./Camera.js": [
		32143
	],
	"./Car": [
		74927
	],
	"./Car.js": [
		74927
	],
	"./CarLift": [
		71384
	],
	"./CarLift.js": [
		71384
	],
	"./Card": [
		37191
	],
	"./Card.js": [
		37191
	],
	"./CategoryAF": [
		5233
	],
	"./CategoryAF.js": [
		5233
	],
	"./CategoryAM": [
		80823
	],
	"./CategoryAM.js": [
		80823
	],
	"./CategoryAR": [
		18821
	],
	"./CategoryAR.js": [
		18821
	],
	"./CategoryAU": [
		28606
	],
	"./CategoryAU.js": [
		28606
	],
	"./CategoryBA": [
		84220
	],
	"./CategoryBA.js": [
		84220
	],
	"./CategoryBB": [
		93976
	],
	"./CategoryBB.js": [
		93976
	],
	"./CategoryBP": [
		15223
	],
	"./CategoryBP.js": [
		15223
	],
	"./CategoryBR": [
		33228
	],
	"./CategoryBR.js": [
		33228
	],
	"./CategoryBS": [
		65019
	],
	"./CategoryBS.js": [
		65019
	],
	"./CategoryCA": [
		17574
	],
	"./CategoryCA.js": [
		17574
	],
	"./CategoryCF": [
		30188
	],
	"./CategoryCF.js": [
		30188
	],
	"./CategoryCI": [
		54521
	],
	"./CategoryCI.js": [
		54521
	],
	"./CategoryCJ": [
		83385
	],
	"./CategoryCJ.js": [
		83385
	],
	"./CategoryCM": [
		67617
	],
	"./CategoryCM.js": [
		67617
	],
	"./CategoryCO": [
		40800
	],
	"./CategoryCO.js": [
		40800
	],
	"./CategoryCP": [
		37419
	],
	"./CategoryCP.js": [
		37419
	],
	"./CategoryCR": [
		72881
	],
	"./CategoryCR.js": [
		72881
	],
	"./CategoryDE": [
		17600
	],
	"./CategoryDE.js": [
		17600
	],
	"./CategoryEA": [
		84636
	],
	"./CategoryEA.js": [
		84636
	],
	"./CategoryED": [
		76910
	],
	"./CategoryED.js": [
		76910
	],
	"./CategoryEP": [
		2875
	],
	"./CategoryEP.js": [
		2875
	],
	"./CategoryES": [
		25682
	],
	"./CategoryES.js": [
		25682
	],
	"./CategoryET": [
		85190
	],
	"./CategoryET.js": [
		85190
	],
	"./CategoryFJ": [
		61295
	],
	"./CategoryFJ.js": [
		61295
	],
	"./CategoryFM": [
		39444
	],
	"./CategoryFM.js": [
		39444
	],
	"./CategoryFS": [
		39965
	],
	"./CategoryFS.js": [
		39965
	],
	"./CategoryGA": [
		39764
	],
	"./CategoryGA.js": [
		39764
	],
	"./CategoryIA": [
		43408
	],
	"./CategoryIA.js": [
		43408
	],
	"./CategoryIM": [
		92943
	],
	"./CategoryIM.js": [
		92943
	],
	"./CategoryIN": [
		92288
	],
	"./CategoryIN.js": [
		92288
	],
	"./CategoryLI": [
		27483
	],
	"./CategoryLI.js": [
		27483
	],
	"./CategoryMD": [
		26416
	],
	"./CategoryMD.js": [
		26416
	],
	"./CategoryME": [
		87159
	],
	"./CategoryME.js": [
		87159
	],
	"./CategoryMO": [
		83559
	],
	"./CategoryMO.js": [
		83559
	],
	"./CategoryMS": [
		25461
	],
	"./CategoryMS.js": [
		25461
	],
	"./CategoryNA": [
		65341
	],
	"./CategoryNA.js": [
		65341
	],
	"./CategoryPA": [
		36258
	],
	"./CategoryPA.js": [
		36258
	],
	"./CategoryPE": [
		78068
	],
	"./CategoryPE.js": [
		78068
	],
	"./CategoryPF": [
		17268
	],
	"./CategoryPF.js": [
		17268
	],
	"./CategoryPI": [
		29661
	],
	"./CategoryPI.js": [
		29661
	],
	"./CategoryRE": [
		20227
	],
	"./CategoryRE.js": [
		20227
	],
	"./CategoryRG": [
		3343
	],
	"./CategoryRG.js": [
		3343
	],
	"./CategorySA": [
		65954
	],
	"./CategorySA.js": [
		65954
	],
	"./CategorySE": [
		59556
	],
	"./CategorySE.js": [
		59556
	],
	"./CategoryTB": [
		99189
	],
	"./CategoryTB.js": [
		99189
	],
	"./CategoryTE": [
		29806
	],
	"./CategoryTE.js": [
		29806
	],
	"./CategoryTF": [
		21694
	],
	"./CategoryTF.js": [
		21694
	],
	"./CategoryUD": [
		82259
	],
	"./CategoryUD.js": [
		82259
	],
	"./CertainExchange": [
		10172
	],
	"./CertainExchange.js": [
		10172
	],
	"./Chat": [
		89480
	],
	"./Chat.js": [
		89480
	],
	"./ChatSuccess": [
		86958
	],
	"./ChatSuccess.js": [
		86958
	],
	"./ChatWarning": [
		63868
	],
	"./ChatWarning.js": [
		63868
	],
	"./Check": [
		70923
	],
	"./Check.js": [
		70923
	],
	"./CheckCircle": [
		19965
	],
	"./CheckCircle.js": [
		19965
	],
	"./CheckThin": [
		9457
	],
	"./CheckThin.js": [
		9457
	],
	"./ChevronDown": [
		14045
	],
	"./ChevronDown.js": [
		14045
	],
	"./ChevronDownCircle": [
		97183
	],
	"./ChevronDownCircle.js": [
		97183
	],
	"./ChevronLeft": [
		49378
	],
	"./ChevronLeft.js": [
		49378
	],
	"./ChevronRight": [
		14515
	],
	"./ChevronRight.js": [
		14515
	],
	"./ChevronUp": [
		37715
	],
	"./ChevronUp.js": [
		37715
	],
	"./Christmas": [
		57416
	],
	"./Christmas.js": [
		57416
	],
	"./Clock": [
		50739
	],
	"./Clock.js": [
		50739
	],
	"./Close": [
		54283
	],
	"./Close.js": [
		54283
	],
	"./CloseCircle": [
		33551
	],
	"./CloseCircle.js": [
		33551
	],
	"./CloseCircleFilled": [
		70643
	],
	"./CloseCircleFilled.js": [
		70643
	],
	"./Coin": [
		85440
	],
	"./Coin.js": [
		85440
	],
	"./Conversation": [
		28983
	],
	"./Conversation.js": [
		28983
	],
	"./Copy": [
		20330
	],
	"./Copy.js": [
		20330
	],
	"./CreditCard": [
		66372
	],
	"./CreditCard.js": [
		66372
	],
	"./Cupom": [
		53465
	],
	"./Cupom.js": [
		53465
	],
	"./CupomPromotion": [
		88060
	],
	"./CupomPromotion.js": [
		88060
	],
	"./CustomerContact": [
		69887
	],
	"./CustomerContact.js": [
		69887
	],
	"./Delivery1h": [
		94825
	],
	"./Delivery1h.js": [
		94825
	],
	"./Delivery24h": [
		64625
	],
	"./Delivery24h.js": [
		64625
	],
	"./DeliveryBox": [
		64521
	],
	"./DeliveryBox.js": [
		64521
	],
	"./DeliveryDefault": [
		88522
	],
	"./DeliveryDefault.js": [
		88522
	],
	"./DeliveryDefaultFilled": [
		66090
	],
	"./DeliveryDefaultFilled.js": [
		66090
	],
	"./DeliveryFree": [
		80013
	],
	"./DeliveryFree.js": [
		80013
	],
	"./DeliveryM": [
		41748
	],
	"./DeliveryM.js": [
		41748
	],
	"./DeliveryRTomorrow": [
		18317
	],
	"./DeliveryRTomorrow.js": [
		18317
	],
	"./DeliverySuccess": [
		4471
	],
	"./DeliverySuccess.js": [
		4471
	],
	"./DeliveryWarning": [
		20061
	],
	"./DeliveryWarning.js": [
		20061
	],
	"./Dislike": [
		71846
	],
	"./Dislike.js": [
		71846
	],
	"./Done": [
		12170
	],
	"./Done.js": [
		12170
	],
	"./DoneCircle": [
		37944
	],
	"./DoneCircle.js": [
		37944
	],
	"./Edit": [
		78218
	],
	"./Edit.js": [
		78218
	],
	"./EmailAt": [
		69185
	],
	"./EmailAt.js": [
		69185
	],
	"./ErrorOutline": [
		76813
	],
	"./ErrorOutline.js": [
		76813
	],
	"./Exchange": [
		22917
	],
	"./Exchange.js": [
		22917
	],
	"./ExchangeCircle": [
		73830
	],
	"./ExchangeCircle.js": [
		73830
	],
	"./ExpressDelivery": [
		16885
	],
	"./ExpressDelivery.js": [
		16885
	],
	"./ExtendedWarranty": [
		95328
	],
	"./ExtendedWarranty.js": [
		95328
	],
	"./Facebook": [
		66244
	],
	"./Facebook.js": [
		66244
	],
	"./FastDelivery": [
		66563
	],
	"./FastDelivery.js": [
		66563
	],
	"./FastMarket": [
		70310
	],
	"./FastMarket.js": [
		70310
	],
	"./FeaturedVideo": [
		32376
	],
	"./FeaturedVideo.js": [
		32376
	],
	"./Filter": [
		99933
	],
	"./Filter.js": [
		99933
	],
	"./GenericImageIcon": [
		68298
	],
	"./GenericImageIcon.js": [
		68298
	],
	"./Guarantee": [
		58823
	],
	"./Guarantee.js": [
		58823
	],
	"./GuaranteeFilled": [
		54795
	],
	"./GuaranteeFilled.js": [
		54795
	],
	"./Heart": [
		77339
	],
	"./Heart.js": [
		77339
	],
	"./HelpOutline": [
		9038
	],
	"./HelpOutline.js": [
		9038
	],
	"./InfoCircle": [
		66099
	],
	"./InfoCircle.js": [
		66099
	],
	"./Instagram": [
		10246
	],
	"./Instagram.js": [
		10246
	],
	"./Lightning": [
		78125
	],
	"./Lightning.js": [
		78125
	],
	"./Like": [
		19302
	],
	"./Like.js": [
		19302
	],
	"./Link": [
		83542
	],
	"./Link.js": [
		83542
	],
	"./LinkedIn": [
		75206
	],
	"./LinkedIn.js": [
		75206
	],
	"./LocalActivity": [
		31304
	],
	"./LocalActivity.js": [
		31304
	],
	"./LogoAliExpress": [
		90918
	],
	"./LogoAliExpress.js": [
		90918
	],
	"./LogoBlogLu": [
		29192
	],
	"./LogoBlogLu.js": [
		29192
	],
	"./LogoEpoca": [
		45832
	],
	"./LogoEpoca.js": [
		45832
	],
	"./LogoEpocaName": [
		99638
	],
	"./LogoEpocaName.js": [
		99638
	],
	"./LogoInfluenciadorMagalu": [
		44756,
		4756
	],
	"./LogoInfluenciadorMagalu.js": [
		44756,
		4756
	],
	"./LogoKabum": [
		76546
	],
	"./LogoKabum.js": [
		76546
	],
	"./LogoMagalu": [
		32153
	],
	"./LogoMagalu.js": [
		32153
	],
	"./LogoMagaluDesktop": [
		5802
	],
	"./LogoMagaluDesktop.js": [
		5802
	],
	"./LogoMagaluRecommends": [
		96106
	],
	"./LogoMagaluRecommends.js": [
		96106
	],
	"./LogoMagazine": [
		605
	],
	"./LogoMagazine.js": [
		605
	],
	"./LogoNetshoesCircle": [
		85450
	],
	"./LogoNetshoesCircle.js": [
		85450
	],
	"./LogoNetshoesName": [
		38936
	],
	"./LogoNetshoesName.js": [
		38936
	],
	"./LogoNetshoesRounded": [
		89165
	],
	"./LogoNetshoesRounded.js": [
		89165
	],
	"./LogoParceiroMagalu": [
		35871
	],
	"./LogoParceiroMagalu.js": [
		35871
	],
	"./LogoZattini": [
		24644
	],
	"./LogoZattini.js": [
		24644
	],
	"./LogoZattiniName": [
		7541
	],
	"./LogoZattiniName.js": [
		7541
	],
	"./LuizaCard": [
		35208
	],
	"./LuizaCard.js": [
		35208
	],
	"./MailOutline": [
		67941
	],
	"./MailOutline.js": [
		67941
	],
	"./MoneyPig": [
		50067
	],
	"./MoneyPig.js": [
		50067
	],
	"./Muted": [
		31055
	],
	"./Muted.js": [
		31055
	],
	"./Notifications": [
		21713
	],
	"./Notifications.js": [
		21713
	],
	"./Offers": [
		81097
	],
	"./Offers.js": [
		81097
	],
	"./OpenLink": [
		42609
	],
	"./OpenLink.js": [
		42609
	],
	"./Package": [
		61610
	],
	"./Package.js": [
		61610
	],
	"./PackageAlert": [
		14996
	],
	"./PackageAlert.js": [
		14996
	],
	"./Person": [
		11257
	],
	"./Person.js": [
		11257
	],
	"./Phone": [
		99073
	],
	"./Phone.js": [
		99073
	],
	"./PickupStore": [
		43094
	],
	"./PickupStore.js": [
		43094
	],
	"./Pin": [
		66857
	],
	"./Pin.js": [
		66857
	],
	"./Pinterest": [
		50986
	],
	"./Pinterest.js": [
		50986
	],
	"./Pix": [
		57298
	],
	"./Pix.js": [
		57298
	],
	"./Play": [
		55235
	],
	"./Play.js": [
		55235
	],
	"./Podcast": [
		17873
	],
	"./Podcast.js": [
		17873
	],
	"./PodcastCircle": [
		98259
	],
	"./PodcastCircle.js": [
		98259
	],
	"./PriceTag": [
		56056
	],
	"./PriceTag.js": [
		56056
	],
	"./PrivacyPolitic": [
		18336
	],
	"./PrivacyPolitic.js": [
		18336
	],
	"./Profile": [
		78438
	],
	"./Profile.js": [
		78438
	],
	"./QRCode": [
		25250
	],
	"./QRCode.js": [
		25250
	],
	"./Question": [
		91152
	],
	"./Question.js": [
		91152
	],
	"./Receipt": [
		3708
	],
	"./Receipt.js": [
		3708
	],
	"./ReturnCircle": [
		12961
	],
	"./ReturnCircle.js": [
		12961
	],
	"./RobberyTheft": [
		56987
	],
	"./RobberyTheft.js": [
		56987
	],
	"./RobberyTheftFull": [
		77018
	],
	"./RobberyTheftFull.js": [
		77018
	],
	"./Rules": [
		9001
	],
	"./Rules.js": [
		9001
	],
	"./Sac": [
		36575
	],
	"./Sac.js": [
		36575
	],
	"./Search": [
		70833
	],
	"./Search.js": [
		70833
	],
	"./SecurityTip": [
		13331
	],
	"./SecurityTip.js": [
		13331
	],
	"./SellerStore": [
		43847
	],
	"./SellerStore.js": [
		43847
	],
	"./Send": [
		50285
	],
	"./Send.js": [
		50285
	],
	"./ServiceBabyShower": [
		48648
	],
	"./ServiceBabyShower.js": [
		48648
	],
	"./ServiceCard": [
		98182
	],
	"./ServiceCard.js": [
		98182
	],
	"./ServiceConsortium": [
		26915
	],
	"./ServiceConsortium.js": [
		26915
	],
	"./ServiceControlPlan": [
		55148
	],
	"./ServiceControlPlan.js": [
		55148
	],
	"./ServiceGoldClient": [
		16030
	],
	"./ServiceGoldClient.js": [
		16030
	],
	"./ServiceHomeIntelligent": [
		14620
	],
	"./ServiceHomeIntelligent.js": [
		14620
	],
	"./ServiceHomeSecurity": [
		1086
	],
	"./ServiceHomeSecurity.js": [
		1086
	],
	"./ServiceLuizaSeg": [
		2492
	],
	"./ServiceLuizaSeg.js": [
		2492
	],
	"./ServiceMagaluEmp": [
		60929
	],
	"./ServiceMagaluEmp.js": [
		60929
	],
	"./ServiceMarketplace": [
		54731
	],
	"./ServiceMarketplace.js": [
		54731
	],
	"./ServiceMarriage": [
		37212
	],
	"./ServiceMarriage.js": [
		37212
	],
	"./ServicePartner": [
		68621
	],
	"./ServicePartner.js": [
		68621
	],
	"./ServiceSolutions": [
		69848
	],
	"./ServiceSolutions.js": [
		69848
	],
	"./Share": [
		80297
	],
	"./Share.js": [
		80297
	],
	"./ShipmentInAccordance": [
		72333
	],
	"./ShipmentInAccordance.js": [
		72333
	],
	"./ShoppingBag": [
		4868
	],
	"./ShoppingBag.js": [
		4868
	],
	"./ShoppingBagFast": [
		98296
	],
	"./ShoppingBagFast.js": [
		98296
	],
	"./Sort": [
		13571
	],
	"./Sort.js": [
		13571
	],
	"./SortArrows": [
		43941
	],
	"./SortArrows.js": [
		43941
	],
	"./Star": [
		57186
	],
	"./Star.js": [
		57186
	],
	"./StarGroup": [
		35233
	],
	"./StarGroup.js": [
		35233
	],
	"./StarHalf": [
		58940
	],
	"./StarHalf.js": [
		58940
	],
	"./StarOutline": [
		64353
	],
	"./StarOutline.js": [
		64353
	],
	"./Store": [
		13750
	],
	"./Store.js": [
		13750
	],
	"./Telegram": [
		84830
	],
	"./Telegram.js": [
		84830
	],
	"./ThumbUp": [
		33737
	],
	"./ThumbUp.js": [
		33737
	],
	"./Tiktok": [
		4774
	],
	"./Tiktok.js": [
		4774
	],
	"./Timer": [
		21342
	],
	"./Timer.js": [
		21342
	],
	"./Tools": [
		18894
	],
	"./Tools.js": [
		18894
	],
	"./TotalSales": [
		86732
	],
	"./TotalSales.js": [
		86732
	],
	"./Tune": [
		40295
	],
	"./Tune.js": [
		40295
	],
	"./Twitter": [
		38830
	],
	"./Twitter.js": [
		38830
	],
	"./Unmuted": [
		94617
	],
	"./Unmuted.js": [
		94617
	],
	"./UserReviewIcon": [
		33112
	],
	"./UserReviewIcon.js": [
		33112
	],
	"./VerifiedBadge": [
		70856
	],
	"./VerifiedBadge.js": [
		70856
	],
	"./Video": [
		80929
	],
	"./Video.js": [
		80929
	],
	"./VideoCircle": [
		11966
	],
	"./VideoCircle.js": [
		11966
	],
	"./ViewModule": [
		65370
	],
	"./ViewModule.js": [
		65370
	],
	"./WarningOutline": [
		81858
	],
	"./WarningOutline.js": [
		81858
	],
	"./WhatsApp": [
		5785
	],
	"./WhatsApp.js": [
		5785
	],
	"./WhatsAppButton": [
		37140
	],
	"./WhatsAppButton.js": [
		37140
	],
	"./Youtube": [
		63724
	],
	"./Youtube.js": [
		63724
	],
	"./index": [
		36868
	],
	"./index.js": [
		36868
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 70017;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 93612:
/***/ (function(module) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 93612;
module.exports = webpackEmptyContext;

/***/ }),

/***/ 35196:
/***/ (function(module) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 35196;
module.exports = webpackEmptyContext;

/***/ }),

/***/ 5349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5163);
/* harmony import */ var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(94843);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _magalu_mixer_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48728);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70314);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _magalu_mixer_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76613);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71453);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14463);
/* harmony import */ var _utils_setCors__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(67088);
/* harmony import */ var _utils_foundCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50161);
/* harmony import */ var _utils_foundError__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(35536);
/* harmony import */ var _utils_setErrorStatus__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(34948);
/* harmony import */ var _utils_isNotFound__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(11957);
/* harmony import */ var _utils_removeFiltersAndRedirect__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47737);
/* harmony import */ var _utils_redirectCanonicalUrl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66480);
/* harmony import */ var _utils_redirectFromRules__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72199);
/* harmony import */ var _utils_redirectToParent__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44917);
/* harmony import */ var _utils_redirectFromQuery__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(64930);
/* harmony import */ var _utils_redirectFromEmpty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65885);
/* harmony import */ var _utils_fetchExternalHtml__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36182);
























var handleRedirects = function(ctx, structure, data) {
    var inventory = [
        (0,_utils_redirectFromQuery__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_utils_logger__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z),
        (0,_utils_redirectCanonicalUrl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_utils_logger__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z),
        (0,_utils_redirectFromEmpty__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_utils_logger__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z), 
    ];
    return inventory.reduce(function(acc, fn) {
        var result = fn({
            ctx: ctx,
            data: data,
            structure: structure
        });
        if (result && !Object.keys(acc).length) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, acc, result);
        }
        return acc;
    }, {});
};
var fetchPromises = function(configToFetch, appConfig, headers) {
    return configToFetch.map(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(item) {
            var url, fetchedData;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!item || !item.name || !item.url) {
                            _utils_logger__WEBPACK_IMPORTED_MODULE_5__/* ["default"].warn */ .Z.warn("[getServerSideProps] Invalid item in externalHTMLToFetch: ".concat(JSON.stringify(item)));
                            return [
                                2,
                                (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, item && item.name || "invalid_item_".concat(Date.now()), null)
                            ];
                        }
                        url = (0,_magalu_mixer_structure__WEBPACK_IMPORTED_MODULE_1__/* .parsePlaceholders */ .VD)(item.url, {
                            config: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, appConfig.publicRuntimeConfig)
                        });
                        return [
                            4,
                            (0,_utils_fetchExternalHtml__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                headers: headers,
                                url: url
                            })
                        ];
                    case 1:
                        fetchedData = _state.sent();
                        return [
                            2,
                            (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, item.name, fetchedData ? fetchedData.html : null)
                        ];
                }
            });
        });
        return function(item) {
            return _ref.apply(this, arguments);
        };
    }());
};
function fetchAllExternalHtmls(structure, config, ctx) {
    return _fetchAllExternalHtmls.apply(this, arguments);
}
function _fetchAllExternalHtmls() {
    _fetchAllExternalHtmls = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(structure, config, ctx) {
        var ref, ref1, externalHtmls, configToFetch, fetchedPromises, resultsArray, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    externalHtmls = {};
                    configToFetch = [];
                    if (Array.isArray(structure.externalHTMLToFetch)) {
                        configToFetch = structure.externalHTMLToFetch;
                    } else if (Array.isArray((ref = structure.template) === null || ref === void 0 ? void 0 : ref.externalHTMLToFetch)) {
                        configToFetch = structure.template.externalHTMLToFetch;
                    }
                    if (configToFetch.length === 0) {
                        return [
                            2,
                            externalHtmls
                        ];
                    }
                    fetchedPromises = fetchPromises(configToFetch, config, ctx === null || ctx === void 0 ? void 0 : (ref1 = ctx.req) === null || ref1 === void 0 ? void 0 : ref1.headers);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        Promise.allSettled(fetchedPromises)
                    ];
                case 2:
                    resultsArray = _state.sent();
                    externalHtmls = resultsArray.reduce(function(acc, current, index) {
                        if ((current === null || current === void 0 ? void 0 : current.status) === "fulfilled" && typeof (current === null || current === void 0 ? void 0 : current.value) === "object") {
                            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, acc, current === null || current === void 0 ? void 0 : current.value);
                        }
                        _utils_logger__WEBPACK_IMPORTED_MODULE_5__/* ["default"].error */ .Z.error("ERROR: fetchAllExternalHtmls - Promise rejected or with unexpected value: ".concat(current.status === "rejected" ? current.reason : current.value));
                        var configItem = configToFetch[index];
                        var itemNameForError = (configItem === null || configItem === void 0 ? void 0 : configItem.name) || "unknown_item_at_index_".concat(index);
                        acc[itemNameForError] = null;
                        return acc;
                    }, {});
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    _utils_logger__WEBPACK_IMPORTED_MODULE_5__/* ["default"].error */ .Z.error("ERROR: fetchAllExternalHtmls - Error during Promise.allSettled or reduce:", error);
                    return [
                        2,
                        {}
                    ];
                case 4:
                    return [
                        2,
                        externalHtmls
                    ];
            }
        });
    });
    return _fetchAllExternalHtmls.apply(this, arguments);
}
function hasInvalidStructure(structure) {
    return !structure || !structure.site || !structure.theme || !structure.components;
}
function handleNotFoundLogicInternal(ctx, structure, span) {
    return _handleNotFoundLogicInternal.apply(this, arguments);
}
function _handleNotFoundLogicInternal() {
    _handleNotFoundLogicInternal = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(ctx, structure, span) {
        var ref, ref1, ref2, hasFilter;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
            if (structure.notfoundFallbackUrl) {
                return [
                    2,
                    (0,_utils_redirectToParent__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(ctx, structure)
                ];
            }
            hasFilter = (ref2 = structure === null || structure === void 0 ? void 0 : (ref = structure.route) === null || ref === void 0 ? void 0 : (ref1 = ref.filters) === null || ref1 === void 0 ? void 0 : ref1.filter(function(filter) {
                return filter.origin !== "url";
            })) === null || ref2 === void 0 ? void 0 : ref2.length;
            if (hasFilter) {
                span === null || span === void 0 ? void 0 : span.addEvent("mixer.filters.not.found", {
                    "log.message": "".concat(ctx.query.filters),
                    "log.severity": "error"
                });
                return [
                    2,
                    (0,_utils_removeFiltersAndRedirect__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(ctx, structure)
                ];
            }
            return [
                2,
                {
                    newCtx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, ctx), {
                        query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, ctx.query),
                        routeId: "404"
                    }),
                    retryAs404: true
                }
            ];
        });
    });
    return _handleNotFoundLogicInternal.apply(this, arguments);
}
function getServerSidePropsCore(ctx) {
    return _getServerSidePropsCore.apply(this, arguments);
}
function _getServerSidePropsCore() {
    _getServerSidePropsCore = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(ctx) {
        var span, ref, structure, cookies, token, ref1, data, errors, config, ref2, trackId, cookieDomain, expires, redirect, found, notFoundAction, externalHtmls, props, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    span = _opentelemetry_api__WEBPACK_IMPORTED_MODULE_19__/* .trace.getActiveSpan */ .g.getActiveSpan();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        ,
                        11
                    ]);
                    return [
                        4,
                        (0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useStructure */ .ab)(ctx)
                    ];
                case 2:
                    structure = _state.sent();
                    if (hasInvalidStructure(structure)) {
                        span === null || span === void 0 ? void 0 : span.addEvent("mixer.not.found.page.structure", {
                            "log.message": "Page cannot be loaded due to structure configs not provided",
                            "log.severity": "error"
                        });
                        return [
                            2,
                            (0,_utils_setErrorStatus__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(ctx, 404, "This page could not be found")
                        ];
                    }
                    if ((0,_utils_isNotFound__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(structure) && (ctx === null || ctx === void 0 ? void 0 : ctx.res)) {
                        ctx.res.statusCode = 404;
                    }
                    (0,_utils_setCors__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(ctx);
                    return [
                        4,
                        (0,_utils_redirectFromRules__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_utils_logger__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            ctx: ctx,
                            structure: structure
                        })
                    ];
                case 3:
                    _state.sent();
                    if (ctx.res.writableEnded) {
                        return [
                            2,
                            {}
                        ];
                    }
                    cookies = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .useCookies */ .fP)(ctx, {
                        logger: _utils_logger__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z
                    });
                    return [
                        4,
                        (0,_magalu_mixer_graphql__WEBPACK_IMPORTED_MODULE_3__.getToken)(structure.site)
                    ];
                case 4:
                    token = _state.sent().token;
                    return [
                        4,
                        (0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useData */ .et)({
                            structure: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, structure), {
                                cookies: cookies
                            }),
                            token: token
                        })
                    ];
                case 5:
                    ref1 = _state.sent(), data = ref1.data, errors = ref1.errors;
                    config = next_config__WEBPACK_IMPORTED_MODULE_2___default()();
                    if (data === null || data === void 0 ? void 0 : (ref = data.search) === null || ref === void 0 ? void 0 : ref.trackId) {
                        ;
                        trackId = data.search.trackId;
                        cookieDomain = config === null || config === void 0 ? void 0 : (ref2 = config.publicRuntimeConfig) === null || ref2 === void 0 ? void 0 : ref2.cookieDomain;
                        expires = new Date();
                        expires.setFullYear(expires.getFullYear() + 1);
                        ctx.res.setHeader("Set-Cookie", [
                            "ml_tid=".concat(trackId, "; Domain=").concat(cookieDomain[structure === null || structure === void 0 ? void 0 : structure.site], "; Expires=").concat(expires, "; path=/;")
                        ]);
                    }
                    (0,_utils_foundError__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(structure, errors);
                    return [
                        4,
                        handleRedirects(ctx, structure, data)
                    ];
                case 6:
                    redirect = _state.sent();
                    if (Object.keys(redirect).length) {
                        return [
                            2,
                            redirect
                        ];
                    }
                    found = (0,_utils_foundCheck__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(structure, data);
                    if (!!found) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        handleNotFoundLogicInternal(ctx, structure, span)
                    ];
                case 7:
                    notFoundAction = _state.sent();
                    if (notFoundAction.retryAs404 && notFoundAction.newCtx) {
                        return [
                            2,
                            getServerSidePropsCore(notFoundAction.newCtx)
                        ];
                    }
                    return [
                        2,
                        notFoundAction
                    ];
                case 8:
                    return [
                        4,
                        fetchAllExternalHtmls(structure, config, ctx)
                    ];
                case 9:
                    externalHtmls = _state.sent();
                    props = {
                        data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, data), {
                            externalHtmls: externalHtmls
                        }),
                        structure: structure
                    };
                    if (structure.ssr) {
                        props.structure.cookies = cookies;
                        if (token) {
                            props.token = token;
                        }
                    }
                    return [
                        2,
                        {
                            props: props
                        }
                    ];
                case 10:
                    e = _state.sent();
                    span === null || span === void 0 ? void 0 : span.addEvent("mixer.render.error.status.500", {
                        "log.message": "Error rendering page on server side: ".concat(e.message),
                        "log.severity": "error"
                    });
                    _utils_logger__WEBPACK_IMPORTED_MODULE_5__/* ["default"].error */ .Z.error("[Core] Error rendering a page in url: ".concat(ctx === null || ctx === void 0 ? void 0 : ctx.resolvedUrl), e);
                    return [
                        2,
                        (0,_utils_setErrorStatus__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(ctx, 500, e.message)
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return _getServerSidePropsCore.apply(this, arguments);
}
function getServerSideProps(ctx) {
    return _getServerSideProps.apply(this, arguments);
}
function _getServerSideProps() {
    _getServerSideProps = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(ctx) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
            return [
                2,
                getServerSidePropsCore(ctx)
            ];
        });
    });
    return _getServerSideProps.apply(this, arguments);
}
/* harmony default export */ __webpack_exports__["Z"] = (getServerSideProps);


/***/ }),

/***/ 25442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ page; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/error.js
var error = __webpack_require__(70689);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../structure/build-esm/index.js + 39 modules
var structure_build_esm = __webpack_require__(48728);
// EXTERNAL MODULE: ../modules/build/esm/index.js
var modules_build_esm = __webpack_require__(54965);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var stereo_ui_icons_build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var graphql_build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/components/Redirect/redirect.js




// Mixer imports


var routeRedirect = function(condition, param, dataSource) {
    var _asPath = param.asPath, asPath = _asPath === void 0 ? "/" : _asPath, fallBack = param.fallBack, _spa = param.spa, spa = _spa === void 0 ? true : _spa, url = param.url;
    var _obj;
    var conditions = (_obj = {
        default: (0,build_esm/* routePush */.dY)({
            path: asPath,
            spa: spa
        })
    }, (0,_define_property/* default */.Z)(_obj, false, (0,build_esm/* routePush */.dY)({
        path: (0,structure_build_esm/* parsePlaceholders */.VD)(fallBack || asPath, dataSource),
        spa: spa
    })), (0,_define_property/* default */.Z)(_obj, true, (0,build_esm/* routePush */.dY)({
        path: (0,structure_build_esm/* parsePlaceholders */.VD)(url, dataSource),
        spa: spa
    })), _obj);
    return conditions[condition] || conditions.default;
};
/**
 * Redirect component used to navigate to a new location.
 * based on: https://v5.reactrouter.com/web/api/Redirect
 * based on: https://www.npmjs.com/package/next-redirects
 *
 * @param {boolean} condition
 * @param {string} fallBack
 * @param {boolean} spa
 * @param {string} url
 * @returns null
 */ function Redirect(param) {
    var condition = param.condition, fallBack = param.fallBack, spa = param.spa, config = param.config, url = param.url;
    var asPath = (0,router.useRouter)().asPath;
    (0,react.useEffect)(function() {
        if (true) {
            routeRedirect(condition !== null && condition !== void 0 ? condition : true, {
                asPath: asPath,
                fallBack: fallBack,
                spa: spa,
                url: url
            }, {
                config: config,
                window: window
            });
        }
    }, [
        condition
    ]);
    return null;
}
Redirect.propTypes = {
    condition: prop_types.bool,
    config: (0,prop_types.shape)({}),
    fallBack: prop_types.string,
    spa: prop_types.bool,
    url: prop_types.string.isRequired
};
/* harmony default export */ var Redirect_redirect = (Redirect);

;// CONCATENATED MODULE: ./src/components/Redirect/index.js


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var next_head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(next_head);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/LazyLoadComponent/index.js + 1 modules
var LazyLoadComponent = __webpack_require__(91785);
;// CONCATENATED MODULE: ./src/components/InScreen/InScreen.js




var InScreen = function(param) {
    var children = param.children, layout = param.layout, options = param.options;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoadComponent/* default */.Z, {
        layout: layout,
        options: options,
        children: children
    });
};
InScreen.propTypes = {
    children: prop_types.node.isRequired,
    layout: (0,prop_types.shape)({}),
    options: (0,prop_types.shape)({
        rootMargin: prop_types.string,
        threshold: prop_types.number
    })
};
InScreen.defaultProps = {
    layout: null,
    options: {
        rootMargin: "250px",
        threshold: 0.1
    }
};
InScreen.ssr = false;
InScreen.displayName = "InScreen";
/* harmony default export */ var InScreen_InScreen = (InScreen);

;// CONCATENATED MODULE: ./src/components/InScreen/index.js


// EXTERNAL MODULE: ./src/utils/shouldRender.js + 1 modules
var shouldRender = __webpack_require__(31328);
;// CONCATENATED MODULE: ./src/components/Target/target.js








var withLazy = function(lazy, children) {
    return lazy ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InScreen_InScreen, {
        options: lazy === null || lazy === void 0 ? void 0 : lazy.options,
        layout: lazy === null || lazy === void 0 ? void 0 : lazy.layout,
        children: children
    }) : children;
};
function Target(_param) {
    var children = _param.children, modules = _param.modules, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "modules"
    ]);
    var slice = props.slice, data = props.data, structure = props.structure, config = props.config, utils = props.utils, moduleProps = (0,_object_without_properties/* default */.Z)(props, [
        "slice",
        "data",
        "structure",
        "config",
        "utils"
    ]);
    var Module = modules[slice === null || slice === void 0 ? void 0 : slice.name];
    return Module && (0,shouldRender/* default */.Z)(props) ? withLazy(!(structure === null || structure === void 0 ? void 0 : structure.isGooglebot) && (slice === null || slice === void 0 ? void 0 : slice.lazy), /*#__PURE__*/ (0,jsx_runtime.jsx)(Module, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: slice.id,
        data: data,
        layout: slice === null || slice === void 0 ? void 0 : slice.layout,
        static: (0,structure_build_esm/* parsePlaceholders */.VD)(slice === null || slice === void 0 ? void 0 : slice.static, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, structure, data), {
            utils: utils
        })),
        structure: structure,
        config: config
    }, moduleProps), {
        children: children
    }))) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}
Target.defaultProps = {
    children: null,
    config: {},
    data: {},
    modules: {},
    structure: {},
    utils: {}
};
Target.propTypes = {
    children: (0,prop_types.oneOfType)([
        prop_types.element,
        prop_types.string,
        (0,prop_types.arrayOf)(prop_types.element),
        prop_types.node
    ]),
    config: (0,prop_types.shape)({}),
    data: (0,prop_types.shape)({}),
    modules: (0,prop_types.shape)({}),
    slice: (0,prop_types.shape)({
        lazy: (0,prop_types.oneOfType)([
            prop_types.bool,
            (0,prop_types.shape)({})
        ]),
        name: prop_types.string.isRequired
    }).isRequired,
    structure: (0,prop_types.shape)({}),
    utils: (0,prop_types.shape)({})
};
/* harmony default export */ var target = (Target);

;// CONCATENATED MODULE: ./src/components/Target/index.js


;// CONCATENATED MODULE: ./src/components/Slice/slice.js







function Slice(props) {
    var ref;
    var slice = props.slice, targetProps = (0,_object_without_properties/* default */.Z)(props, [
        "slice"
    ]);
    var renderChildren = function(sliceChild) {
        if (!sliceChild) return null;
        if (sliceChild.children) {
            return renderChildren(sliceChild.children);
        }
        if (Array.isArray(sliceChild)) {
            return sliceChild.map(function(c) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(target, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    slice: c
                }, targetProps), {
                    children: renderChildren(c === null || c === void 0 ? void 0 : c.children)
                }), c.id);
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(target, (0,_object_spread/* default */.Z)({
            slice: sliceChild
        }, targetProps), sliceChild.id);
    };
    if (slice.type === "group") {
        var ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            style: {
                gridArea: "".concat(slice.grid_id)
            },
            children: (ref1 = slice.components) === null || ref1 === void 0 ? void 0 : ref1.map(function(child) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(target, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, targetProps), {
                    slice: child,
                    children: renderChildren(child)
                }), child.id);
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(target, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: (ref = slice.children) === null || ref === void 0 ? void 0 : ref.map(function(child) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(target, (0,_object_spread/* default */.Z)({
                slice: child
            }, targetProps), child.id);
        })
    }));
}
Slice.defaultProps = {
    config: {},
    data: {},
    structure: {}
};
Slice.propTypes = {
    config: (0,prop_types.shape)({}),
    data: (0,prop_types.shape)({}),
    slice: (0,prop_types.shape)({
        name: prop_types.string
    }).isRequired,
    structure: (0,prop_types.shape)({})
};
/* harmony default export */ var Slice_slice = (Slice);

;// CONCATENATED MODULE: ./src/components/Slice/index.js


;// CONCATENATED MODULE: ./src/components/Meta/meta.js









var Meta = function(param) {
    var tags = param.tags, data = param.data;
    var getKey = function(key, dataSource) {
        if (!key) return null;
        if (typeof key === "string") return (0,structure_build_esm/* parsePlaceholders */.VD)(key, dataSource);
        var value = (0,structure_build_esm/* parsePlaceholders */.VD)(key, dataSource).value;
        return value === null || value === void 0 ? void 0 : value.toString();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0 maximum-scale=1.0"
            }),
            tags === null || tags === void 0 ? void 0 : tags.map(function(item, idx) {
                var parsedItem = Object.keys(item).reduce(function(result, key) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), (0,_define_property/* default */.Z)({}, key, getKey(item[key], data)));
                }, {});
                var type = parsedItem.type, children = parsedItem.children, other = (0,_object_without_properties/* default */.Z)(parsedItem, [
                    "type",
                    "children"
                ]);
                var props = (0,_object_spread/* default */.Z)({
                    "data-testid": "link-".concat(idx),
                    key: idx
                }, other);
                return /*#__PURE__*/ react.createElement(type, props, children);
            })
        ]
    });
};
Meta.defaultProps = {
    data: {},
    tags: []
};
Meta.propTypes = {
    data: (0,prop_types.shape)({}),
    tags: (0,prop_types.arrayOf)((0,prop_types.shape)({}))
};
/* harmony default export */ var meta = (Meta);

;// CONCATENATED MODULE: ./src/components/Meta/index.js


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/lodash/omit.js
var omit = __webpack_require__(17620);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ./src/components/MainContainer/globalStyles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-height: 100vh;\n\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n\n  ",
        "\n\n  html, body {\n    margin: unset;\n    background-color: ",
        ";\n    color: ",
        ";\n    font-family: ",
        ";\n  }\n  ol, ul {\n    list-style: none;\n  }\n  *, *:before, *:after {\n    box-sizing: border-box;\n    text-decoration: none;\n  }\n  body {\n    position: relative;\n  }\n  a:hover{\n    border:0px solid transparent;\n  }\n  a:focus {\n    border: 0px solid transparent;\n  }\n  a:focus-visible{\n    outline: auto 1px Highlight;\n    outline: auto 1px -webkit-focus-ring-color;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Container = styled_components_browser_esm["default"].main.attrs(function(props) {
    return {
        bg: props.layout.bg
    };
}).withConfig({
    componentId: "sc-f0cf7f7-0"
})(_templateObject(), function(props) {
    return omit_default()(props.layout, [
        "bg"
    ]);
}, stereo_ui_styles_build_esm.color);
var getFontFace = function() {
    var fonts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Object.keys(fonts).map(function(key) {
        return {
            "@font-face": {
                "font-display": "swap",
                "font-family": "'".concat(fonts[key].fontFamily, "'"),
                "font-style": "normal",
                "font-weight": "".concat(fonts[key].fontWeight),
                src: fonts[key].src
            }
        };
    });
};
var StyleResets = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject1(), function(props) {
    var ref, ref1;
    return getFontFace((ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.fonts) === null || ref1 === void 0 ? void 0 : ref1.variations);
}, function(props) {
    return (0,stereo_ui_styles_build_esm.getPaletteColor)("background.base")(props);
}, function(props) {
    return (0,stereo_ui_styles_build_esm.getTextColor)("base")(props);
}, function(props) {
    var ref, ref1;
    return (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.fonts) === null || ref1 === void 0 ? void 0 : ref1.name;
});

;// CONCATENATED MODULE: ./src/components/MainContainer/mainContainer.js













var CANONICAL_QUERY_PARAMS_ALLOWLIST = [
    "filters"
];
var removeCanonicalQuery = function(canonical) {
    if (!canonical || typeof canonical !== "string") return canonical;
    var ref = (0,_sliced_to_array/* default */.Z)(canonical.split("?"), 1), baseCanonical = ref[0];
    return baseCanonical;
};
var getCanonicalMeta = function(canonicalPath) {
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)(((ref = canonicalPath === null || canonicalPath === void 0 ? void 0 : canonicalPath.toLowerCase()) === null || ref === void 0 ? void 0 : ref.split("?")) || [], 2), tmp = ref1[0], path = tmp === void 0 ? "" : tmp, tmp1 = ref1[1], rawQuery = tmp1 === void 0 ? "" : tmp1;
    var searchParams = new URLSearchParams(rawQuery);
    var filteredSearchParams = new URLSearchParams();
    CANONICAL_QUERY_PARAMS_ALLOWLIST.forEach(function(param) {
        searchParams.getAll(param).forEach(function(value) {
            filteredSearchParams.append(param, value);
        });
    });
    var parameter = filteredSearchParams.toString();
    return {
        parameter: parameter ? "?".concat(parameter) : "",
        path: path.slice(1)
    };
};
var MainContainer = function(param) {
    var structure = param.structure, data = param.data, config = param.config, modules = param.modules;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var _ref = structure || {}, components = _ref.components, head = _ref.head, metaTags = _ref.metaTags, _layout = _ref.layout, layout = _layout === void 0 ? {} : _layout, pageInfo = (0,_object_without_properties/* default */.Z)(_ref, [
        "components",
        "head",
        "metaTags",
        "layout"
    ]);
    var publish = (0,esm/* usePublisher */.Np)().publish;
    var canonicalMeta = getCanonicalMeta(structure === null || structure === void 0 ? void 0 : structure.canonicalPath);
    var seoSearchCanonical = removeCanonicalQuery(data === null || data === void 0 ? void 0 : (ref = data.seoSearchContent) === null || ref === void 0 ? void 0 : (ref1 = ref.meta) === null || ref1 === void 0 ? void 0 : ref1.canonical);
    (0,react.useEffect)(function() {
        if ((structure === null || structure === void 0 ? void 0 : structure.name) === "conta") {
            publish("pageviewspace");
            return;
        }
        publish("pageview");
        publish("setpagebeforelogin", (0,build_esm/* removeSpacesAndAccents */.qA)(structure === null || structure === void 0 ? void 0 : structure.name));
    }, [
        JSON.stringify(structure)
    ]);
    var hasLayout = Object.entries(layout).length;
    var Wrapper = hasLayout ? Container : react.Fragment;
    var wrapperProps = hasLayout ? {
        layout: layout
    } : {};
    var renderSlice = function(slice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slice_slice, {
            slice: slice,
            data: data,
            structure: pageInfo,
            config: config,
            utils: {
                getFullTitle: build_esm/* getFullTitle */.HV
            },
            modules: modules
        }, slice.id || slice.grid_id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: head === null || head === void 0 ? void 0 : head.map(renderSlice)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, wrapperProps), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(meta, {
                        tags: metaTags,
                        data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data, structure), {
                            meta: {
                                alternate: structure === null || structure === void 0 ? void 0 : (ref2 = structure.config) === null || ref2 === void 0 ? void 0 : ref2.alternateDomain,
                                canonical: structure === null || structure === void 0 ? void 0 : (ref3 = structure.config) === null || ref3 === void 0 ? void 0 : ref3.canonicalDomain,
                                filters: {
                                    brand: (0,build_esm/* parseFiltersMetaTags */.zA)(data === null || data === void 0 ? void 0 : (ref4 = data.search) === null || ref4 === void 0 ? void 0 : ref4.filters, "brand")
                                },
                                ogImage: (ref9 = data === null || data === void 0 ? void 0 : (ref5 = data.product) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.image) === null || ref6 === void 0 ? void 0 : ref6.replace("{w}", structure === null || structure === void 0 ? void 0 : (ref7 = structure.config) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.images) === null || ref8 === void 0 ? void 0 : ref8.width)) === null || ref9 === void 0 ? void 0 : ref9.replace("{h}", structure === null || structure === void 0 ? void 0 : (ref10 = structure.config) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.images) === null || ref11 === void 0 ? void 0 : ref11.height),
                                parameter: canonicalMeta.parameter,
                                path: canonicalMeta.path
                            },
                            seoSearchContent: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data === null || data === void 0 ? void 0 : data.seoSearchContent), {
                                meta: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data === null || data === void 0 ? void 0 : (ref12 = data.seoSearchContent) === null || ref12 === void 0 ? void 0 : ref12.meta), {
                                    canonical: seoSearchCanonical
                                })
                            }),
                            utils: {
                                getFullTitle: build_esm/* getFullTitle */.HV
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleResets, {}),
                    components === null || components === void 0 ? void 0 : components.map(renderSlice)
                ]
            }))
        ]
    });
};
MainContainer.defaultProps = {
    config: {},
    modules: {}
};
MainContainer.propTypes = {
    config: (0,prop_types.shape)({}),
    data: (0,prop_types.shape)({}).isRequired,
    modules: (0,prop_types.shape)({}),
    structure: (0,prop_types.shape)({}).isRequired
};
/* harmony default export */ var mainContainer = (MainContainer);

;// CONCATENATED MODULE: ./src/components/MainContainer/index.js


// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../events/build/esm/index.js
var events_build_esm = __webpack_require__(52898);
;// CONCATENATED MODULE: ./src/components/EventSubscriber/eventSubscriber.js








var eventsInventory = events_build_esm.inventory.reduce(function(acc, eventType) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, eventType, dynamic_default()(function() {
        return __webpack_require__(37752)("./".concat(eventType)).then(function(param) {
            var events = param.default;
            return function EventSubscriberComponent() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Subscriber */.Lv, {
                    events: events
                });
            };
        });
    })));
}, {});
function EventSubscriber(param) {
    var types = param.types;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: types.filter(function(type) {
            return !!eventsInventory[type];
        }).map(function(type) {
            var Module = eventsInventory[type];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Module, {}, "event-subscriber-".concat(type));
        })
    });
}
EventSubscriber.defaultProps = {
    types: []
};
EventSubscriber.propTypes = {
    types: (0,prop_types.arrayOf)(prop_types.string)
};
/* harmony default export */ var eventSubscriber = (EventSubscriber);

;// CONCATENATED MODULE: ./src/components/EventSubscriber/index.js


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/lodash/get.js
var get = __webpack_require__(72579);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ../../node_modules/next/config.js
var next_config = __webpack_require__(70314);
var config_default = /*#__PURE__*/__webpack_require__.n(next_config);
;// CONCATENATED MODULE: ./src/hocs/withPrivateRoute.js












// Redirect component

var verifyLoginFromKey = function(structure, data) {
    var privateRouteCheck = (0,structure_build_esm/* parsePlaceholders */.VD)(structure.privateRouteCheck, (0,_object_spread/* default */.Z)({}, structure, data));
    if (privateRouteCheck) return false;
    return true;
};
var isAPrivateRoute = function(param) {
    var config = param.config, isPrivate = param.private;
    return isPrivate && !!(config === null || config === void 0 ? void 0 : config.loggedUser) && !!(config === null || config === void 0 ? void 0 : config.loginUrl);
};
var userIsLogged = function(structure) {
    var config = structure.config;
    return !!get_default()(structure, config === null || config === void 0 ? void 0 : config.loggedUser, false);
};
var withPrivateRoute = function(Page) {
    var WrapComponent = function(props) {
        var ref;
        var initialStructure = props.structure, data = props.data;
        var back = (0,router.useRouter)().back;
        var config = config_default()();
        var publicRuntimeConfig = config.publicRuntimeConfig;
        var cookies = build_esm/* whereAmI.onClient */.er.onClient ? (0,build_esm/* useCookies */.fP)({}, {
            config: config
        }) : initialStructure === null || initialStructure === void 0 ? void 0 : initialStructure.cookies;
        var structure = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialStructure), {
            cookies: cookies
        });
        var ref1 = (0,react.useState)(!!(structure === null || structure === void 0 ? void 0 : structure.private) && !!(structure === null || structure === void 0 ? void 0 : (ref = structure.config) === null || ref === void 0 ? void 0 : ref.isMiniApp)), validateAppLogin = ref1[0], setValidateAppLogin = ref1[1];
        var checkMiniAppLogin = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var logger, logged, error, ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            logger = (0,build_esm/* Logger */.Yd)(structure === null || structure === void 0 ? void 0 : structure.config);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4,
                                (0,build_esm/* useCheckUserCredentials */.tI)(logger)
                            ];
                        case 2:
                            logged = _state.sent();
                            if (!!logged) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0,build_esm/* useRequestUserCredential */.uY)(logger)
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            setValidateAppLogin(false);
                            return [
                                3,
                                6
                            ];
                        case 5:
                            error = _state.sent();
                            return [
                                2,
                                (window === null || window === void 0 ? void 0 : (ref = window.history) === null || ref === void 0 ? void 0 : ref.length) > 1 ? back() : (0,build_esm/* useCloseMiniApp */.aX)(logger)
                            ];
                        case 6:
                            return [
                                2,
                                null
                            ];
                    }
                });
            });
            return function checkMiniAppLogin() {
                return _ref.apply(this, arguments);
            };
        }();
        var shouldRedirect = build_esm/* whereAmI.onClient */.er.onClient && verifyLoginFromKey(structure, data) && isAPrivateRoute(structure) && !userIsLogged(structure);
        if (build_esm/* whereAmI.onClient */.er.onClient && validateAppLogin) {
            checkMiniAppLogin();
            return null;
        }
        if (shouldRedirect) {
            var ref2;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Redirect_redirect, {
                config: publicRuntimeConfig,
                url: structure === null || structure === void 0 ? void 0 : (ref2 = structure.config) === null || ref2 === void 0 ? void 0 : ref2.loginUrl,
                spa: false
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            config: config,
            cookies: cookies,
            structure: structure
        }));
    };
    WrapComponent.defaultProps = {
        data: {},
        structure: {}
    };
    WrapComponent.propTypes = {
        data: (0,prop_types.shape)({}),
        structure: (0,prop_types.shape)({})
    };
    return WrapComponent;
};
withPrivateRoute.propTypes = {
    page: prop_types.node
};
/* harmony default export */ var hocs_withPrivateRoute = (withPrivateRoute);

;// CONCATENATED MODULE: ./src/containers/default/page.js
















var Page = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, structure = ref.structure, config = ref.config, cookies = ref.cookies, data = ref.data, errorCode = ref.errorCode, errorTitle = ref.errorTitle, redirect = ref.redirect, token = ref.token, modules = ref.modules;
    var ref1, ref2, ref3;
    if (errorCode) return /*#__PURE__*/ (0,jsx_runtime.jsx)(error["default"], {
        statusCode: errorCode,
        title: errorTitle
    });
    var parsedStructure = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, structure), {
        config: (0,structure_build_esm/* parsePlaceholders */.VD)(structure === null || structure === void 0 ? void 0 : structure.config, {
            config: config.publicRuntimeConfig
        })
    });
    return build_esm/* whereAmI.onClient */.er.onClient && redirect ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Redirect_redirect, {
        url: redirect,
        spa: false
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(graphql_build_esm.ClientProvider, {
        config: config,
        cookies: cookies,
        token: token,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* PublisherProvider */.qk, {
            settings: {
                config: config.publicRuntimeConfig,
                data: data,
                structure: parsedStructure
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(eventSubscriber, {
                    types: (structure === null || structure === void 0 ? void 0 : (ref1 = structure.config) === null || ref1 === void 0 ? void 0 : ref1.events) || []
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stereo_ui_icons_build_esm/* IconProvider */.jSL, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(graphql_build_esm.WishlistProvider, {
                        values: {
                            userId: structure === null || structure === void 0 ? void 0 : (ref2 = structure.cookies) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.accountData) === null || ref3 === void 0 ? void 0 : ref3.id
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modules_build_esm.AdsContext, {
                            structure: parsedStructure,
                            data: data,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainContainer, {
                                structure: parsedStructure,
                                data: data,
                                config: config,
                                modules: modules
                            })
                        })
                    })
                })
            ]
        })
    });
};
Page.defaultProps = {
    config: {},
    cookies: {},
    data: {},
    errorCode: 0,
    errorTitle: "",
    modules: {},
    redirect: "",
    structure: {},
    token: ""
};
Page.propTypes = {
    config: (0,prop_types.shape)({}),
    cookies: (0,prop_types.shape)({}),
    data: (0,prop_types.shape)({}),
    errorCode: prop_types.number,
    errorTitle: prop_types.string,
    modules: (0,prop_types.shape)({}),
    redirect: prop_types.string,
    structure: (0,prop_types.shape)({
        theme: (0,prop_types.shape)({})
    }),
    token: prop_types.string
};
/* harmony default export */ var page = (hocs_withPrivateRoute(Page));


/***/ }),

/***/ 87333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qk": function() { return /* reexport */ PublisherProvider; },
  "Lv": function() { return /* reexport */ esm_Subscriber; },
  "Np": function() { return /* reexport */ esm_usePublisher; }
});

// UNUSED EXPORTS: Consumer, Provider, Publisher, PublisherContext

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(9249);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(87371);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(11987);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(95058);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(45754);
// EXTERNAL MODULE: ../../node_modules/events/events.js
var events = __webpack_require__(22699);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
;// CONCATENATED MODULE: ../publisher/build/esm/Publisher.js








function _callSuper(t, o, e) { return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var Publisher = function (_EventEmitter) {
  function Publisher() {
    var _this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$events = _ref.events,
      events = _ref$events === void 0 ? {} : _ref$events,
      _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? {} : _ref$settings,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 100 : _ref$delay;
    (0,classCallCheck/* default */.Z)(this, Publisher);
    _this = _callSuper(this, Publisher);
    _this.publish = _this.publish.bind(_this);
    _this.subscribe = _this.subscribe.bind(_this);
    _this.unsubscribe = _this.unsubscribe.bind(_this);
    _this.subscribeAll = _this.subscribeAll.bind(_this);
    _this.publishAllQueue = _this.publishAllQueue.bind(_this);
    _this.publishQueue = _this.publishQueue.bind(_this);
    _this.settings = settings;
    _this.eventQueue = [];
    _this.emitterReady = false;
    _this.subscribeAll(events);
    setTimeout(function () {
      _this.publishAllQueue();
    }, delay);
    return _this;
  }
  (0,inherits/* default */.Z)(Publisher, _EventEmitter);
  return (0,createClass/* default */.Z)(Publisher, [{
    key: "publish",
    value: function publish(event) {
      var eventQueue = this.eventQueue.filter(function (_ref2) {
        var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 1),
          e = _ref3[0];
        return e !== event;
      });
      if (esm/* whereAmI.onClient */.er.onClient) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        if (this.emitterReady) {
          var _window, _window$crypto;
          var eventId = (_window = window) == null ? void 0 : (_window$crypto = _window.crypto) == null ? void 0 : _window$crypto.randomUUID == null ? void 0 : _window$crypto.randomUUID();
          this.emit.apply(this, [event].concat(args, [(0,esm_extends/* default */.Z)({}, this.settings, {
            eventId: eventId
          })]));
          if (this.eventQueue.length !== eventQueue.length) {
            this.eventQueue = eventQueue;
          }
        } else {
          this.eventQueue.push([event, args]);
        }
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(event, callback) {
      if (esm/* whereAmI.onClient */.er.onClient) {
        this.removeListener(event, callback);
        this.addListener(event, callback);
      }
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(event, callback) {
      if (esm/* whereAmI.onClient */.er.onClient) {
        this.removeListener(event, callback);
      }
    }
  }, {
    key: "subscribeAll",
    value: function subscribeAll(events) {
      var _this2 = this;
      Object.entries(events).forEach(function (_ref4) {
        var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 2),
          name = _ref5[0],
          callback = _ref5[1];
        if (Array.isArray(callback)) {
          callback.forEach(function (cb) {
            _this2.subscribe(name, cb);
          });
        } else {
          _this2.subscribe(name, callback);
        }
      });
    }
  }, {
    key: "publishAllQueue",
    value: function publishAllQueue() {
      var _this3 = this;
      this.emitterReady = true;
      this.eventQueue.forEach(function (_ref6) {
        var _ref7 = (0,slicedToArray/* default */.Z)(_ref6, 2),
          event = _ref7[0],
          args = _ref7[1];
        return _this3.publish.apply(_this3, [event].concat((0,toConsumableArray/* default */.Z)(args)));
      });
    }
  }, {
    key: "setSettings",
    value: function setSettings(settings) {
      this.settings = settings;
    }
  }, {
    key: "publishQueue",
    value: function publishQueue(event) {
      var eventQueue = this.eventQueue.find(function (_ref8) {
        var _ref9 = (0,slicedToArray/* default */.Z)(_ref8, 1),
          e = _ref9[0];
        return e === event;
      });
      if (eventQueue) {
        var _eventQueue = (0,slicedToArray/* default */.Z)(eventQueue, 2),
          evt = _eventQueue[0],
          args = _eventQueue[1];
        this.publish.apply(this, [evt].concat((0,toConsumableArray/* default */.Z)(args)));
      }
    }
  }]);
}(events.EventEmitter);
/* harmony default export */ var esm_Publisher = ((0,esm/* Singleton */.eG)(Publisher));
;// CONCATENATED MODULE: ../publisher/build/esm/Context.js


var PublisherContext = (0,react.createContext)();
var Provider = PublisherContext.Provider,
  Consumer = PublisherContext.Consumer;

var PublisherProvider = function PublisherProvider(_ref) {
  var children = _ref.children,
    events = _ref.events,
    settings = _ref.settings;
  var publisher = new esm_Publisher({
    events: events
  });
  publisher.setSettings(settings);
  return react.createElement(Provider, {
    value: publisher
  }, children);
};
;// CONCATENATED MODULE: ../publisher/build/esm/usePublisher.js


var usePublisher = function usePublisher() {
  return (0,react.useContext)(PublisherContext);
};
/* harmony default export */ var esm_usePublisher = (usePublisher);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../publisher/build/esm/Subscriber.js


var Subscriber = function Subscriber(_ref) {
  var events = _ref.events;
  var _usePubliser = esm_usePublisher(),
    subscribeAll = _usePubliser.subscribeAll;
  subscribeAll(events);
  return null;
};
Subscriber.propTypes = {
  events: (0,prop_types.shape)({}).isRequired
};
/* harmony default export */ var esm_Subscriber = (Subscriber);
;// CONCATENATED MODULE: ../publisher/build/esm/index.js





/***/ })

}]);